import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';

export class ExportFileService {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/export-file',
        exportTemplate: (modelName: string) =>
            `/api/export-file/export-template/${modelName}`,
    };

    public downloadTemplate(modelName: string): Promise<Blob> {
        const url = this.endpoints.exportTemplate(modelName);

        return this.apiClient.fetchBlob(url);
    }
}
